import { getImageUrl } from "./getImageUrl";

const download = (url: string, filename: string) => {
  var element = document.createElement("a");
  element.setAttribute("href", url);
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export const handleEpaperClipDownload = async (filename: string) => {
  try {
    const imageUrl = getImageUrl(filename);
    const result = await fetch(imageUrl, {
      method: "GET",
      headers: {},
    });
    const blob = await result.blob();
    const url = URL.createObjectURL(blob);
    download(url, `epaper-cut`);

    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error(error);
  }
};
